import React from 'react'

function NotAuthorized() {
  return (
    <div>NotAuthorized</div>
  )
}

export default NotAuthorized